module.exports = __webpack_public_path__ + "img/logo-dark.9a151825.png";